import React, { useState,useEffect } from 'react';

import axios from 'axios';
import { useParams,useHistory } from "react-router-dom";

import {Configs} from '../api';

const EditTodo =()=> {
    let history= useHistory();
    const id =useParams({})
  const [name, setname] = useState('')
  const [price, setprice] = useState('')
  
const [catLoc, setcatLoc] = useState('')

const [barCategories, setCategories] = useState([])

  const adddata = async(e) =>{

    try {
    console.log(name,price,catLoc)
    const result = await axios.post(Configs.items+'/'+id.id,
    {
      name : name,
      price : price,
      categoryId :catLoc
    })
    console.log(result)
   history.push('/dashboard/items')
    
  }
    catch (error) {
      console.log(error.message);
  }
  }


  useEffect(() => {
    const dataID = async() =>{

      try {
      const result = await axios.get(Configs.items+'/'+id.id)
      // console.log(result.data.items)
      setname(result.data.item.name)
      setprice(result.data.item.price)

     
    }
      catch (error) {
        console.log(error.message);
    }
    }
    const loadLocations= async()=>{
      // console.log(catLoc)
      try {
        const result = await axios.get(Configs.categories)
        // console.log(result.data.location)
        setCategories(result.data.categories)
      }
        catch (error) {
          console.log(error.message);
      }
      }
    
    

    dataID();
    loadLocations();
  },[id.id]);
  
  return ( 

<div className="container-fluid box-styl" >
<h1 className="text-center mt-5">Edit Items</h1>
<form className="d-flex mt-5 mb-5 algnItm"  onSubmit={e=>{adddata(e)}}>
<input type='text' 
          className="form-control input-styl1"
          value={name}
          onChange={e=> setname(e.target.value)}
            required
        >
           </input>

           <input type='text' 
          className="form-control input-styl1"
          value={price}
          onChange={e=> setprice(e.target.value)}
            required
        >
           </input>

        <select id="dropdown" 
        value={barCategories._id} 
        className="form-control input-styl"
        onChange={(e)=>setcatLoc(e.target.value)} 
        required
        >
        
        <option value='' >select Category</option>
        {barCategories.map((loc)=>(
          
       
          <option key={loc._id} value={loc._id}>{loc.name}</option>
        )
        )
        }
          
        </select>
       
          <button className="btn btn-success">Edit</button>

</form>
</div>
);
}

    
     
    export default EditTodo;